import jQuery from 'jquery';
/** Exposing "$ = jQuery" globally as it is used by some blade components */
window.$ = jQuery;
